export type ThemeTokens = typeof DEFAULT_TOKENS_LIGHT;

export const DEFAULT_TOKENS_LIGHT = {
  'color-primary': '#6C7A88',
  'color-primary-hover': '#5A6875',
  'color-primary-foreground': '#FFFFFF',
  'color-primary-subtle': '#EBEEF1',
  'color-success': '#7DCBA8',
  'color-warning': '#E8B86D',
  'color-error': '#D98A8A',
  'color-info': '#7BAED4',
  'color-background': '#F5F5F3',
  'color-surface': '#FFFFFF',
  'color-surface-elevated': '#EDEDEB',
  'color-border': '#D5D5D0',
  'color-text': '#1C1C1E',
  'color-text-secondary': '#6B6B70',
  'color-text-muted': '#A0A0A5',
  'font-family':
    '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
  'font-size-xs': '11px',
  'font-size-sm': '13px',
  'font-size-base': '15px',
  'font-size-lg': '17px',
  'font-size-xl': '20px',
  'font-size-2xl': '24px',
  'space-1': '4px',
  'space-2': '8px',
  'space-3': '12px',
  'space-4': '16px',
  'space-5': '20px',
  'space-6': '24px',
  'space-8': '32px',
  'radius-sm': '4px',
  'radius-md': '8px',
  'radius-lg': '12px',
  'radius-full': '9999px',
  'shadow-sm': '0 1px 2px rgba(0,0,0,0.05)',
  'shadow-md': '0 4px 6px rgba(0,0,0,0.07)',
  'shadow-lg': '0 10px 15px rgba(0,0,0,0.1)',
};

export function getDefaultTokens(theme: 'light' | 'dark') {
  return theme === 'light' ? DEFAULT_TOKENS_LIGHT : DEFAULT_TOKENS_DARK;
}

export const DEFAULT_TOKENS_DARK = {
  // Colors (dark mode variants)
  'color-primary': '#8FA0B0',
  'color-primary-hover': '#A0B0BF',
  'color-primary-foreground': '#FFFFFF',
  'color-primary-subtle': '#2A3040',
  'color-success': '#6BB896',
  'color-warning': '#D4A65C',
  'color-error': '#C47878',
  'color-info': '#6A9DC2',
  'color-background': '#1C1C1E',
  'color-surface': '#2A2A2E',
  'color-surface-elevated': '#353538',
  'color-border': '#404045',
  'color-text': '#EDEDEB',
  'color-text-secondary': '#9A9A9E',
  'color-text-muted': '#6B6B70',
  // Typography (shared with light mode)
  'font-family':
    '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
  'font-size-xs': '11px',
  'font-size-sm': '13px',
  'font-size-base': '15px',
  'font-size-lg': '17px',
  'font-size-xl': '20px',
  'font-size-2xl': '24px',
  // Spacing (shared with light mode)
  'space-1': '4px',
  'space-2': '8px',
  'space-3': '12px',
  'space-4': '16px',
  'space-5': '20px',
  'space-6': '24px',
  'space-8': '32px',
  // Border radius (shared with light mode)
  'radius-sm': '4px',
  'radius-md': '8px',
  'radius-lg': '12px',
  'radius-full': '9999px',
  // Shadows (shared with light mode)
  'shadow-sm': '0 1px 2px rgba(0,0,0,0.05)',
  'shadow-md': '0 4px 6px rgba(0,0,0,0.07)',
  'shadow-lg': '0 10px 15px rgba(0,0,0,0.1)',
};
